import angular from 'angular';

class BrandsPermissionsModalContainer {
  constructor(
    $q,
    appEvents,
    appSessionCapabilities,
    brands,
    permissions,
    users,
    BRANDS_EVENTS,
  ) {
    'ngInject';

    this.$q = $q;
    this.appEvents = appEvents;
    this.appSessionCapabilities = appSessionCapabilities;
    this.brands = brands;
    this.permissions = permissions;
    this.users = users;
    this.BRANDS_EVENTS = BRANDS_EVENTS;

    this.removeOpenSubscription = this.appEvents.on(
      this.BRANDS_EVENTS.modal.open,
      (brand, usersList, forEdition) => this.openModal(
        brand,
        angular.copy(usersList),
        forEdition,
      ),
    );

    this.modalTitle = 'Assign Permissions';
    this.brand = {};
    this.usersList = [];
    this.editMode = false;
    this.canAssign = false;
    this.open = false;
    this.ownerCaption = '';
  }
  $onDestroy() {
    this.removeOpenSubscription();
  }
  updateModalTitle(users) {
    const name = this.brand.displayName;
    const twoUsersOrMore = 2;
    let title = '';
    if (!this.canAssign) {
      const [user] = users;
      title = `View Permissions For ${user.displayName}`;
    } else if (this.editMode && users.length > 1) {
      title = `Update Permissions For ${users.length} Selected Users`;
    } else if (this.editMode && users.length === 1) {
      const [user] = users;
      title = `Update Permissions For ${user.displayName}`;
    } else if (!this.editMode && users.length < twoUsersOrMore) {
      title = `Assign User to ${name}`;
    } else {
      title = `Assign Users to ${name}`;
    }

    this.modalTitle = title;
  }
  openModal(brand, usersList, forEdition) {
    this.brand = brand;
    this.usersList = usersList;
    this.open = true;
    this.editMode = forEdition;
    this.canAssign = this.appSessionCapabilities.canAssignBrandToNewUser();
    this.ownerCaption = `${this.brand.displayName} [${this.brand.photorank_id}]`;
    this.updateModalTitle(this.usersList);
  }
  closeModal() {
    this.open = false;
    this.appEvents.emit(this.BRANDS_EVENTS.modal.close);
  }
  saveModal() {
    this.appEvents.emit(this.BRANDS_EVENTS.modal.save);
    this.closeModal();
  }
}

export default {
  controller: BrandsPermissionsModalContainer,
  template: `
    <modal-wrapper
      ng-if="$ctrl.open"
      modal-title="$ctrl.modalTitle"
      on-close="$ctrl.closeModal()"
      full-height="true"
    >
      <permissions-form-container
        on-save="$ctrl.saveModal()"
        on-cancel="$ctrl.closeModal()"

        owner-label="Account"
        owner-caption="$ctrl.ownerCaption"

        users-list="$ctrl.usersList"
        show-users="true"
        can-add-users="$ctrl.canAssign"
        can-remove-all-users="!$ctrl.editMode"
        on-users-change="$ctrl.updateModalTitle(users)"

        brands-list="[$ctrl.brand]"
        show-brands="false"
      ></permissions-form-container>
    </modal-wrapper>
  `,
};
